// This file was copied from DX's UIDEV repo. It is a dependency for history's popover. It was intentionally left unchanged so that future potential merging would be easier
// tslint:disable

import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, fromEvent } from 'rxjs';
import { pluck, distinctUntilChanged, map } from 'rxjs/operators';

function _window() : any {
    // return the global native browser window object
    return window;
}

@Injectable()
export class BrowserWindow {
    get nativeWindow() : any {
        return _window();
    }

    width$:Observable<number>;
    height$:Observable<number>;

    constructor() {
        let winSize$ = new BehaviorSubject(getWindowSize());

        this.height$ = (winSize$.pipe(pluck('height'), distinctUntilChanged())) as Observable<number>;
        this.width$ = (winSize$.pipe(pluck('width'), distinctUntilChanged())) as Observable<number>;

        fromEvent(window, 'resize').pipe(map(getWindowSize)).subscribe(winSize$);
    }
}

function getWindowSize() {
    return {
        height : _window().innerHeight,
        width : _window().innerWidth
    }
}
